import { object, string, number } from 'yup'

import { COMMENT_MAX_LENGTH } from './constants'

export default object().shape({
  rate: number().required(),
  comment: string().default('').max(COMMENT_MAX_LENGTH)
})
